// @flow
import { getECommerceTokenApiLink } from '../selectors/configSelectors';
import { select, call } from 'redux-saga/effects';
import $url from 'url';
import { myAxaFetchWithToken } from '../../../utils/myAxaFetchWithToken';
import { getLanguage } from '../../../selectors/userSelectors';
import env from '../../../env';

export function* fetchECommToken(action: any): any {
  const requestUrl = yield select(getECommerceTokenApiLink);

  try {
    const response = yield call(myAxaFetchWithToken, requestUrl, {
      method: 'GET',
    });

    if (response.status === 200) {
      const responseJson = yield response.json();
      return {
        status: response.status,
        payload: {
          body: responseJson.access_token,
        },
        url: requestUrl,
        error: undefined,
      };
    } else {
      return {
        status: response.status,
        url: requestUrl,
        error: undefined,
      };
    }
  } catch (error) {
    return {
      status: 404,
      url: requestUrl,
      error: error,
    };
  }
}

export function* fetchFunnelLink(action: any): any {
  try {
    const { payload } = action;
    const { link, query } = payload;

    const urlObj = $url.parse(link);

    const baseUrlQuery = {
      promote: query.promoCode,
      channel: 'eb',
      hide: '1',
    };

    const genderUrlQuery = {
      dob: query.dob,
      gender: query.gender,
      habit: query.habbit,
    };

    let finalUrlQuery = {
      ...baseUrlQuery,
    };
    if (query.gender) {
      finalUrlQuery = {
        ...baseUrlQuery,
        ...genderUrlQuery,
      };
    }

    const requestUrl = $url.format({
      slashes: true,
      protocol: urlObj.protocol,
      pathname: urlObj.pathname,
      host: urlObj.host,
      query: finalUrlQuery,
    });

    const language = yield select(getLanguage);

    const response = yield call(myAxaFetchWithToken, requestUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `${action.token}`,
        'User-Agent': `EMMA/${env.WEBAPP_VERSION}`, // TODO - Add web portal version
        'x-ui-lang': `${language}`,
        'x-axa-all-in-one-partner': 'emma',
      },
    });

    if (response.status === 200) {
      const responseJson = yield response.text();
      return {
        status: response.status,
        payload: {
          body: responseJson,
        },
        url: requestUrl,
        error: undefined,
      };
    } else {
      return {
        status: response.status,
        url: requestUrl,
        error: undefined,
      };
    }
  } catch (error) {
    return {
      status: 404,
      url: '',
      error: error,
    };
  }
}
